export default __webpack_public_path__ + "static/media/24.55bba0cc.jpg";